export default "__VITE_ASSET__DG5Xszgk__"